import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-line-of-business-detail',
  templateUrl: './line-of-business-detail.component.html',
  styleUrls: ['./line-of-business-detail.component.scss']
})
export class LineOfBusinessDetailComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
